import {Injectable} from "@angular/core";
import {Headers, Http, Response} from "@angular/http";
import "rxjs/add/operator/map";

@Injectable()
export class RestrictionsService {

    private readonly DEFAULT_DAYS = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30];

    private baseUrl: string = '../rest/company';

    constructor(private http : Http) {}

    getDefaultRestrictions(companyOid): any{
        return this.http
            .get(`${this.baseUrl}/${companyOid}/restrictions`)
            .map((res:any) => res.json());
    }

    getRestrictions(companyOid): any {
        return this.http
            .get(`${this.baseUrl}/${companyOid}/point-of-sale/restrictions`)
            .map((res:any) => res.json());
    }

    /*Default*/
    update(restrictions, companyOid: number) {
        return this.http.post(`${this.baseUrl}/${companyOid}/restrictions`, restrictions);
    }

    updatePosRestriction(restriction, companyOid: number) {
        var posOid = restriction.pointOfSaleOid;
        var oid = restriction.oid;
        return this.http.put(`${this.baseUrl}/${companyOid}/point-of-sale/${posOid}/restrictions/${oid}`, restriction);
    }

    addPosRestriction(restriction, companyOid: number) {
        var posOid = restriction.pointOfSaleOid;
        return this.http.post(`${this.baseUrl}/${companyOid}/point-of-sale/${posOid}/restrictions`, restriction);
    }

    deleteSpecialSetting(companyOid: number, oid: number, pointOfSaleOid: number){
        return this.http.delete(`${this.baseUrl}/${companyOid}/point-of-sale/${pointOfSaleOid}/restrictions/${oid}`);
    }

    private getHeaders(){
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return myHeaders;
    }

    getBaseUrl(){
        return this.baseUrl;
    }

    /*LIST DEFINITIONS*/
    getDaysInAdvanceList(){
        return [{ id: 0, value: 0}, { id: 1, value: 1}, { id: 2, value: 2}, { id: 3, value: 3}, { id: 4, value: 4}, { id: 5, value: 5}];
    }


    getMinDurationList(){
        var minDurationList = [];
        var i = 1;
        for (i; i < 30; i++){
            minDurationList.push({id: i, value: i })
        }
        return minDurationList;
    }

    getMaxDurationList(minRental){
        var list = this.DEFAULT_DAYS.slice(minRental, 30);
        var listMax = [], i = 0;
        for (i; i < list.length; i++){
            listMax.push({id: list[i], value: list[i] })
        }
        return listMax;
    }

    buildRestrictionsMap(restrictions: any[], context: any) {
        restrictions.forEach(item => {
            context.totalRestrictions[item.oid] = item;
        })
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/restrictions/restrictions.service.ts